import * as Colors from '../../utils/design/colors';
import {MID_DESKTOP_MIN, TABLET_LANDSCAPE_MAX} from '../../utils/design/breakpoints';
import { useWindowSize } from '../../../utils/hooks/use-window-size';

export const customStyles = (isFocused, formActive, isMobile) => ({
  control: (provided) => ({
    ...provided,
    boxShadow: null,
    border: 'none',
    minHeight: 0,
    backgroundColor: 'transparent',
    flex: 1,
    cursor: 'text'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: formActive && !isFocused ? Colors.GRAY_500 : Colors.GRAY_600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
    transition: 'all 0.2s ease',
    fontSize: isMobile ? '18px' : '16px',
    lineHeight: '24px'
  }),
  input: (provided) => ({
    ...provided,
    color: formActive && !isFocused ? Colors.GRAY_500 : Colors.GRAY_900,
    margin: 0,
    transition: 'all 0.2s ease',
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: isMobile ? '18px' : '16px',
    lineHeight: '24px'
  }),
  option: (provided, state) => {
    const windowDims = useWindowSize();
    const optionStyles = {
      ...provided,
      backgroundColor: state.isFocused ? Colors.GRAY_200 : null,
      color: Colors.GRAY_900,
      cursor: 'pointer',
      padding: '8px 16px',
      '@media (min-width: 645px)': {
        padding: '8px 40px'
      },
      '@media (min-width: 1440px)': {
        padding: '8px 80px'
      }
    };
    if (!isMobile) {
      optionStyles['&:hover'] = {
        backgroundColor: Colors.GRAY_200
      };
    }
    return optionStyles;
  },
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    width: '0px',
    overflow: 'hidden'
  }),
  menu: (provided) => {
    return {
      ...provided,
      top: !isMobile ? provided.top : '41px',
      left: 0,
      right: 0,
      bottom: !isMobile ? provided.bottom : '0',
      margin: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: '2px',
      borderBottomRightRadius: '2px',
      boxShadow: 'none'
    };
  },
  menuList: (provided) => {
    return {
      ...provided,
      paddingTop: 0
    };
  },
  container: (provided) => {
    return {
      ...provided,
      position: 'static',
      display: 'flex',
      flex: isMobile ? 0 : 1
    };
  }
});
